import { findSqlReportOptions } from 'api';
import Spinner from 'components/Spinner';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import EditCrontabForm from './EditCrontabForm';

class ReportCrontabModal extends Component {
  state = {
    loading: false,
    timezoneOptions: [],
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevProps.isOpen &&
      this.props.isOpen &&
      !this.state.timezoneOptions.length
    ) {
      this.loadTimezones();
    }
  }

  loadTimezones = () => {
    const { sqlReport } = this.props;
    findSqlReportOptions(sqlReport.id)
      .then((res) => {
        const choices =
          res.data &&
          res.data.actions.GET.crontab_schedule.children.timezone.choices;
        const timezoneOptions = choices.map(({ value, display_name }) => [
          value,
          display_name,
        ]);
        this.setState({ timezoneOptions });
      })
      .catch((e) => console.log(e));
  };

  onSubmit = (values) => {
    const { updateSqlReport, sqlReport, closeModal } = this.props;
    const crontabSchedule = sqlReport.crontab_schedule;
    const newCrontabSchedule = {
      ...crontabSchedule,
      ...values,
    };

    if (
      newCrontabSchedule.timezone === '' ||
      (newCrontabSchedule.timezone && newCrontabSchedule.timezone.trim() === '')
    ) {
      delete newCrontabSchedule.timezone;
    }

    this.setState({ loading: true });
    return updateSqlReport(sqlReport.id, {
      crontab_schedule: newCrontabSchedule,
    })
      .then(() => closeModal())
      .catch((err) => {
        if (err.errors && err.errors.crontab_schedule) {
          err.errors = err.errors.crontab_schedule;
        }
        throw err;
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleDelete = () => {
    const { updateSqlReport, sqlReport, closeModal } = this.props;

    return updateSqlReport(sqlReport.id, {
      crontab_schedule: {},
    })
      .then(() => closeModal())
      .catch((err) => {
        if (err.errors && err.errors.crontab_schedule) {
          err.errors = err.errors.crontab_schedule;
        }
        throw err;
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  getInitialValues = () => {
    const { sqlReport } = this.props;
    const crontabSchedule = sqlReport.crontab_schedule || {};
    return crontabSchedule;
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { loading, timezoneOptions } = this.state;

    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={isOpen}
        contentLabel="Minimal Modal Example"
        portalClassName="AdjustmentCreditPortal"
        overlayClassName="AdjustmentCreditModal__Overlay"
        className="AdjustmentCreditModal__Content"
      >
        <div className="modal-header">
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <h2>Edit crontab schedule</h2>
        </div>
        <div className="modal-body">
          <EditCrontabForm
            onSubmit={this.onSubmit}
            handleDelete={this.handleDelete}
            initialValues={this.getInitialValues()}
            closeModal={closeModal}
            timezoneOptions={timezoneOptions}
          />
        </div>
        <Spinner showLoader={loading} />
      </ReactModal>
    );
  }
}

export default ReportCrontabModal;
